const tw = {
  currencyList: {
    hkd: '港幣$',
    cny: '人民幣￥'
  },
  payBefore: {
    pending: '待付款',
    totalPrice: '總價',
    paymentClosingDate: '付款截至日期',
    customerInformation: '客戶信息',
    telephone: '電話',
    name: '姓名',
    mailbox: '郵箱',
    mailboxTips: '請輸入您的郵箱地址，我們會發送訂單信息到您的郵箱',
    logistics: '物流', // 确认一下
    logisticsMode: {
      title: '物流方式',
      mode1: '無物流',
      mode2: '送貨或自取',
      mode3: '送貨',
      mode4: '自取'
    },
    expectedDeliveryTime: '預期送貨時間:',
    remarks: '備注',
    terms: '本人清楚及瞭解有關推廣活動條款細節及',
    termsLink: '隱私政策',
    payNow: '支付',
    errorMessage: {
      phone: '電話號碼未填寫',
      phoneFormate: '電話號碼格式不正確',
      name: '姓名未填寫',
      logisticsMode: '請選擇物流方式',
      otherValid: '不可輸入特殊字符',
      invalidEmail: '無效的郵箱格式'
    },
    placeholder: {
      name: '請輸入姓名',
      phone: '請輸入電話',
      email: '請輸入郵箱',
      address: '請輸入地址'
    }
  },
  privacyPolicy: {
    head: '隱私政策',
    contentTitle: '當您訪問由 QFPay Haojin Fintech Limited 託管的QFPay網站時，請與我們聯繫，使用QFPay商家APP或成為（或正在成為我們的商人或合作夥伴之一，我們將作為數據控制者處理有關您的個人數據。對我們而言，重要的是，應謹慎對待應用程序用戶，網站訪問者，（潛在）商人和（未來）合作夥伴（“您”）的訪問者的個人數據，並且您應充分了解我們處理您的個人數據的方式。通過選擇 QFPay Haojin Fintech Limited。（“ QFPay”，“我們”，“我們”或“我們的”）作為您的支付服務技術解決方案提供商。我們完全致力於確保我們收集的所有信息以及用戶權利得到良好保護。本隱私政策描述了我們將在qfpay.global（“網站”）上收集的信息類型，信息的使用案例以及您與之相關的權利。',
    title_one: '1.我們收集的個人信息',
    content_one: `當您訪問本網站時，我們會自動收集有關您設備的某些信息，包括有關您的Web瀏覽器，IP地址，時區以及設備上安裝的某些Cookie的信息。此外，在您瀏覽網站時，我們會收集有關您查看的各個網頁或產品的信息，哪些網站或搜索字詞將您引薦到該網站以及有關您如何與該網站進行交互的信息。我們將此自動收集的信息稱為“設備信息”。我們使用以下技術收集設備信息：-“ Cookie”是放置在設備或計算機上的數據文件，通常包含匿名唯一標識符。有關cookie以及如何禁用cookie的更多信息，請訪問http://www.allaboutcookies.org。
    -“日誌文件”跟踪網站上發生的操作，並收集數據，包括您的IP地址，瀏覽器類型，Internet服務提供商，引薦/退出頁面和日期/時間戳。
    -“網絡信標”，“標籤”和“像素”是用於記錄有關您如何瀏覽網站的信息的電子文件。
    
    此外，當您嘗試通過電子郵件或聯繫表通過網站與我們聯繫或與我們聯繫時，我們會從您那裡收集某些信息，包括您的姓名，電子郵件地址，位置，個人信息和電話號碼。我們將此信息稱為“聯繫信息”。當我們在本隱私政策中談論“個人信息”時，我們既在談論設備信息又在訂購信息。`,
    title_two: '2.我們如何使用您的個人信息',
    content_two: `我們使用通常收集的訂單信息來處理通過網站發出的聯繫請求（包括處理您的個人或公司信息，安排產品演示並向您提供有關產品和服務的數據和/或信息）。此外，我們使用此聯繫信息來：
    與您交流；
    篩選我們的訂單以發現潛在的風險或欺詐行為；和
    根據您與我們分享的偏好，向您提供與我們的產品或服務有關的信息或廣告。
    
    我們使用收集到的設備信息來幫助我們篩查潛在的風險和欺詐行為（特別是您的IP地址），並且更廣泛地改善和優化我們的網站（例如，通過生成有關客戶如何瀏覽和互動的分析）網站，並評估我們的營銷和廣告活動的成功）。
    如上所述，我們與第三方共享您的個人信息，以幫助我們使用您的個人信息。例如，我們使用Google Analytics（分析）來幫助我們了解客戶如何使用本網站-您可以在此處閱讀有關Google如何使用您的個人信息的更多信息：https://www.google.com/intl/zh-CN/policies/privacy/ 。您還可以在此處退出Google Analytics（分析）：https：//tools.google.com/dlpage/gaoptout。最後，我們還可能會分享您的個人信息，以遵守適用的法律和法規，以回應傳票，搜查令或其他合法要求提供的信息，或以其他方式保護我們的權利。`,
    title_three: '3.行為廣告',
    content_three: '如上所述，我們使用您的個人信息為您提供有針對性的廣告或市場傳播信息，我們認為您可能對此感興趣。有關定向廣告如何工作的更多信息，您可以訪問網絡廣告計劃（“ NAI”）的教育頁面，網址為http://www.networkadvertising.org/understanding-online-advertising/how-does-it-work。',
    title_four: '4.您的權利',
    content_four: '如果您是歐洲居民，則有權訪問我們持有的有關您的個人信息，並要求更正，更新或刪除您的個人信息。如果您想行使此權利，請通過以下聯繫信息與我們聯繫。此外，如果您是歐洲居民，請注意，我們正在處理您的聯繫請求以便為您提供服務。',
    title_five: '5.數據保留',
    content_five: '當您通過本網站創建聯繫請求時，除非您要求我們刪除此信息，否則我們將保留您的個人信息作為我們的記錄。 我們可能會不時更新本隱私政策，以反映（例如）我們做法的更改或出於其他運營，法律或法規方面的原因。',
    title_six: '6.聯繫我們',
    content_six: `有關我們的隱私慣例的更多信息，如果您有任何疑問，或者您想提出投訴，請通過電子郵件發送給我們：客戶服務部 hkcs@qfpay.com。錢方好近金融科技有限公司，香港長沙灣荔枝角道777號天時企業中心12樓1207-09室。

    本隱私政策的最新更新時間為2021年8月05日。`
  },
  payResult: {
    result: '支付結果',
    voucher: '憑證',
    paymentVoucher: '支付凴證',
    mchtName: '店鋪名稱:',
    mchtOrderId: '商戶訂單號:',
    payOrderId: '支付訂單號:',
    payTime: '支付時間:',
    totalPrice: '總價:',
    logisticsMode: {
      title: '物流方式:',
      mode1: '無物流',
      mode2: '送貨或自取',
      mode3: '送貨',
      mode4: '自取'
    },
    mchtAddress: '店鋪地址:',
    address: '地址:',
    mchtMailbox: '店鋪郵箱:',
    mchtTelephone: '店鋪電話:',
    accept: '本人欲知曉及接受QFPAY Haojin Fintech Limited的最新消息及推廣',
    confirm: '確認',
    queryStatus: '訂單狀態查詢',
    payAgain: '再次支付',
    status: '狀態:',
    customerName: '客戶姓名:',
    CustomerTelephone: '客戶電話:',
    success: '成功',
    failure: '失敗',
    processing: '處理中',
    save: '保存',
    saveTo: '保存到相冊'
  }
}

export default tw
